import t from "react";
import { EnvironmentContext as n } from "./context.js";
function r() {
  return t.useContext(n);
}
export {
  r as useEnvironment
};
//# sourceMappingURL=useEnvironment.js.map
